export enum HttpStatusCode {
    CONTINUE = 100,
    SWITCHING_PROTOCOLS = 101,
    OK = 200,
    CREATED = 201,
    ACCEPTED = 202,
    NON_AUTHORITATIVE_INFORMATION = 203,
    NO_CONTENT = 204,
    RESET_CONTENT = 205,
    PARTIAL_CONTENT = 206,
    MULTIPLE_CHOICES = 300,
    MOVED_PERMANENTLY = 301,
    FOUND = 302,
    SEE_OTHER = 303,
    NOT_MODIFIED = 304,
    USE_PROXY = 305,
    TEMPORARY_REDIRECT = 307,
    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    PAYMENT_REQUIRED = 402,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    METHOD_NOT_ALLOWED = 405,
    NOT_ACCEPTABLE = 406,
    PROXY_AUTHENTICATION_REQUIRED = 407,
    REQUEST_TIMEOUT = 408,
    CONFLICT = 409,
    GONE = 410,
    LENGTH_REQUIRED = 411,
    PRECONDITION_FAILED = 412,
    REQUEST_ENTITY_TOO_LARGE = 413,
    REQUEST_URI_TOO_LONG = 414,
    UNSUPPORTED_MEDIA_TYPE = 415,
    REQUESTED_RANGE_NOT_SATISFIABLE = 416,
    EXPECTATION_FAILED = 417,
    UNPROCESSABLE_ENTITY = 422,
    TOO_MANY_REQUESTS = 429,
    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED = 501,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
    HTTP_VERSION_NOT_SUPPORTED = 505,
}

export interface IPepperError extends Error {
  code: string;
  httpCode: HttpStatusCode;
  data?: object;
  isRetryable?: boolean;
}

export function isPepperError(item: any): item is IPepperError {
  return typeof item.code === 'string' &&
      typeof item.httpCode === 'number' &&
      typeof item.message === 'string' &&
      (item.data ? typeof item.data === 'object' : true) &&
      (typeof item.isRetryable !== 'undefined' ? typeof item.isRetryable === 'boolean' : true);
}

export function getPepperErrorCode(errorCode: any): {code: number; prefix: string } | undefined {
    if (typeof errorCode === 'string' && errorCode.length === 10) {
        const parts = errorCode.split('-');
        if (parts.length === 3 && parts[0] === 'E' && parts[1].length === 3) {
            const code = parseInt(parts[2], 10);
            if (!isNaN(code)) {
                return { code, prefix: parts[1] };
            }
        }
    }
}
export class PepperError extends Error implements IPepperError {
  public name: string = 'Pepper Error';

  public static makeStdCode(code: number, prefix: string) {
    return 'E-' + prefix + '-' + ('0000' + code).slice(-4);
  }

  public getErrorCode = (): number => { return +this.code.slice(-4); };

  constructor(public code: string, public httpCode: HttpStatusCode,
      public message: string, public data?: object, public isRetryable?: boolean) {
    super();
  }
}
